import React from 'react'
import superfaceAnimation from '../json/superface.json'
import {Flex} from '../components/layout'
import Lottie from 'lottie-web'

export default class HomeAnimation extends React.Component {
    
    direction = 1

    options = {
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData : superfaceAnimation
    }
    
    constructor(props){
        super(props)
        this.handleResize = this.handleResize.bind(this)
    }

    componentDidMount(){
        this.animation = Lottie.loadAnimation(
            {...this.options, container : this.container}
        )
        // this.animation.play()
        window.addEventListener('resize', this.handleResize )
        // window.addEventListener('mousemove', this.handleMove)
    }

    componentWillUnmount(){
        // window.removeEventListener('mousemove', this.handleMove)
        this.animation.stop()
    }

    handleResize(){
        if(this.timeout) clearTimeout(this.timeout)
        this.timeout = setTimeout( () => { this.setState({}) }, 200 )
    }

    render(){
        let style = { position:'absolute', zIndex:300, height:'100%', width:'100%'}
        let animationStyle = {
            transform : `rotate(${ window.innerWidth / window.innerHeight < 1 ? '-90' : '0'}deg)`,
            transformOrigin : 'center center',
            width:'55%',
            margin:'auto'
        } 
        
        return(
            <Flex align='center' style={style} id="home-animation">
                <div ref={this.props.setRef} style={{width:'100%'}}>
                    <div style={animationStyle} ref={ container => { this.container = container }}></div>
                </div>
            </Flex> 
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/HomeAnimation.js